import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import * as moment from "moment";
import * as _ from "underscore";
import { Subject, Subscription, fromEvent } from "rxjs";
import { debounceTime, distinctUntilChanged, map } from "rxjs/operators";
import { ApiService } from "app/modules/shared/services/api.service";
import { AnalyticService } from "app/modules/shared/services/analytic.service";
import { Router } from "@angular/router";
import * as FileSaver from "file-saver";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { CryptoService } from "app/shared/utils/crypto.service";

@Component({
  selector: 'app-members-tab-stars-lesson-session-count-analtics',
  templateUrl: './members-tab-stars-lesson-session-count-analtics.component.html',
  styleUrls: ['./members-tab-stars-lesson-session-count-analtics.component.scss']
})
export class MembersTabStarsLessonSessionCountAnalticsComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource([]);
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild("searchInput", { static: false }) searchInput: ElementRef;
  @Input() selectedApp: any;
  @Input() dateData$: Subject<any>;
  @Input() userName: string;
  isShowDate: boolean = false;
  isMessage: boolean = false;
  isPage: boolean = true;
  listDateRange: any = "daySelected";
  listDates: any = "";
  totalDifficultPSets: any;
  leastDifficultPSetsList = [];
  date: any;
  dateInfo: any;
  subsink: Subscription;

  constructor(public analyticService: AnalyticService, public router: Router, public api: ApiService, private crypto: CryptoService) {}

  ngOnInit() {
    this.displayedColumns = ["lessonName", "totalSession", "averageDuration"];
    
    this.subsink = this.dateData$.pipe(debounceTime(500), distinctUntilChanged()).subscribe((v) => {
      if (v) {
        this.dateInfo = v;
        this.triggerDateSelection(v);
      }
    });
  }

  triggerDateSelection(data) {
    switch (data.type) {
      case "Day": {
        this.daySelected();
        break;
      }
      case "Month": {
        this.monthSelected();
        break;
      }
      case "Year": {
        this.yearSelected();
        break;
      }
      case "range": {
        this.rangeSelected(data);
        break;
      }
    }
  }

  daySelected() {
    // this.toShowExpandText = false;
    this.practiceSetSelected("daySelected");
    // this.sessionPlayedDaySelected('daySelected');
    // this.renderChartForSessionPlayedByDay(this.selectedDateForDay);

    // Set the calendar range to the last 31 days
    const currentDate = new Date();
    const startDate = new Date();
    startDate.setDate(currentDate.getDate() - 30);

    this.date = {
      startDate: startDate,
      endDate: currentDate,
    };
  }

  monthSelected() {
    // this.toShowExpandText = false;
    this.practiceSetSelected("monthSelected");
    // this.sessionPlayedMonthSelected('monthSelected');
    // this.renderChartForSessionPlayedByMonth(this.selectedMonth);

    // Set the calendar range to show the last 2 years
    const today = new Date();
    const twoYearsAgo = new Date(today.getFullYear() - 2, today.getMonth(), today.getDate());
    this.date = {
      startDate: twoYearsAgo,
      endDate: today,
    };
  }

  yearSelected() {
    this.practiceSetSelected("yearSelected");
    // this.sessionPlayedYearSelected('yearSelected');
    const today = new Date();
    const fourYearsAgo = new Date(today.getFullYear() - 5, today.getMonth(), today.getDate());
    this.date = {
      startDate: fourYearsAgo,
      endDate: today,
    };
  }

  rangeSelected(result) {
    // this.sessionPlayedYearSelected('rangeSelected');
    let startDate = moment(result.startDate).format("YYYY-MM-DD");
    let endDate = moment(result.endDate).format("YYYY-MM-DD");
    this.difficultPSetsOnDateRange(startDate, endDate);
    this.date = {
      startDate: startDate,
      endDate: endDate,
    };
  }

  async practiceSetSelected(data) {
    this.isShowDate = false;
    this.isMessage = false;
    let selectData: string = "";
    if (data == "daySelected") {
      this.listDateRange = "daySelected";
      selectData = "day";
      this.listDates = moment(new Date()).subtract(1, "d").format("YYYY-MM-DD") + " To " + moment(new Date()).format("YYYY-MM-DD");
    } else if (data == "monthSelected") {
      this.listDateRange = "monthSelected";
      selectData = "month";
      this.listDates = moment(new Date()).subtract(1, "M").format("YYYY-MM-DD") + " To " + moment(new Date()).format("YYYY-MM-DD");
    } else if (data == "yearSelected") {
      this.listDateRange = "yearSelected";
      selectData = "year";
      this.listDates = moment(new Date()).subtract(1, "y").format("YYYY-MM-DD") + " To " + moment(new Date()).format("YYYY-MM-DD");
    }
    this.totalDifficultPSets = [];
    let nameStr = this.crypto.isProbablyEncrypted(this.userName) ? this.userName : await this.crypto.encryptData(this.userName);
    this.analyticService.getPracticeSetData(selectData, this.selectedApp.id, nameStr).subscribe(
      (res) => {
        let dataList: any = res;
        this.isPage = false;
        if (!_.isUndefined(dataList)) {
          if (dataList["leastDifficult"].length == 0) {
            this.isMessage = true;
          }
          if (!_.isUndefined(dataList["leastDifficult"]) && dataList["leastDifficult"].length != 0) {
            let lDPSets = dataList["leastDifficult"];
            this.leastDifficultPSetsList = lDPSets.map((v) => ({ ...v, pSetSuffix: this.api.getNameSuffix(v.name) }));
            this.totalDifficultPSets = this.leastDifficultPSetsList;
            this.dataSource = new MatTableDataSource(this.totalDifficultPSets);
            this.dataSource.sortingDataAccessor = (data: any, sortHeaderId: string): string => {
              if (typeof data[sortHeaderId] === "string") return data[sortHeaderId].toLocaleLowerCase();
              return data[sortHeaderId];
            };
            this.paginator.firstPage();
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          } else this.totalDifficultPSets = [];
        } else this.totalDifficultPSets = [];
      },
      (err) => {
        this.api.getError(err);
        this.isPage = true;
        this.isMessage = true;
      }
    );
  }

  applyFilter() {
    const searchPS = fromEvent<any>(this.searchInput.nativeElement, "keyup").pipe(
      map((event) => event.target.value),
      debounceTime(500),
      distinctUntilChanged()
    );
    searchPS.subscribe((res) => {
      this.dataSource.filter = res.trim().toLowerCase();
    });
  }

  async difficultPSetsOnDateRange(startDate, endDate) {
    this.leastDifficultPSetsList = [];
    this.totalDifficultPSets = [];
    this.isPage = true;
    this.isMessage = false;
    let nameStr = this.crypto.isProbablyEncrypted(this.userName) ? this.userName : await this.crypto.encryptData(this.userName);
    this.analyticService.getDifficultPOnDateRangeSets(startDate, endDate, this.selectedApp.id, nameStr).subscribe(
      (res) => {
        let dataList = res;
        this.isPage = false;
        this.listDateRange = moment(startDate).format("MM/DD/YYYY") + " - " + moment(endDate).format("MM/DD/YYYY");
        this.isShowDate = true;
        this.listDates = moment(startDate).format("MM/DD/YYYY") + " - " + moment(endDate).format("MM/DD/YYYY");
        if (!_.isUndefined(dataList) && !_.isUndefined(dataList["leastDifficult"])) {
          if (dataList["leastDifficult"].length == 0) this.isMessage = true;
        }
        if (!_.isUndefined(dataList["leastDifficult"]) && dataList["leastDifficult"].length != 0) {
          let lDPSets = dataList["leastDifficult"];
          this.leastDifficultPSetsList = lDPSets.map((v) => ({ ...v, pSetSuffix: this.api.getNameSuffix(v.name) }));
          this.totalDifficultPSets = this.leastDifficultPSetsList;
          this.dataSource = new MatTableDataSource(this.totalDifficultPSets);
          this.dataSource.sortingDataAccessor = (data: any, sortHeaderId: string): string => {
            if (typeof data[sortHeaderId] === "string") return data[sortHeaderId].toLocaleLowerCase();
            return data[sortHeaderId];
          };
          this.paginator.firstPage();
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        } else this.totalDifficultPSets = [];
      },
      (err) => {
        this.api.getError(err);
        this.isPage = true;
        this.isMessage = true;
      }
    );
  }

  isFiniteNumber(value: number): boolean {
    return isFinite(value);
  }

  openPracSetAnalyticsView(data) {
    //this.api.addRoute(0, this.selectedApp.title, this.selectedApp.id);
    //localStorage.setItem("selectedApp", JSON.stringify({ ...this.selectedApp, dataId: data.lessonId }));
    //this.router.navigate(["main/practiceSet/analytics/view", "detail", data.lessonId, data.lessonName]);  
    this.router.navigate(["main/practiceSet/analytics/user", "detail", data.lessonId, data.lessonName, this.userName]);
  }

  openFolderAnalyticsView(data) {
    this.api.addRoute(0, this.selectedApp.title, this.selectedApp.id);
    if (data.folder !== null) {
      this.router.navigate(["main/folderAnalytics/app", data.folderId, this.selectedApp.title, data.folder]);
    }
  }

  async exportCsvData(analyticsType) {
    let dateType;
    if (this.listDateRange == "daySelected") dateType = "day";
    else if (this.listDateRange == "monthSelected") dateType = "month";
    else if (this.listDateRange == "yearSelected") dateType = "year";
    else if (this.listDateRange == "rangeSelected") {
      dateType = "range";
    }
    let requestParam = "";
    try {
      let nameStr = this.crypto.isProbablyEncrypted(this.userName) ? this.userName : await this.crypto.encryptData(this.userName);
      this.analyticService.getCsvData(analyticsType, dateType, this.date.startDate, this.date.endDate, this.selectedApp.id, requestParam, nameStr).subscribe(
        (data) => {
          let dataObject: any = data;
          if (data.type === "application/zip") {
            var blob = new Blob([data], { type: data.type });
            FileSaver.saveAs(blob, analyticsType.toUpperCase() + ".zip");
          } else {
            var blob = new Blob([data], { type: "application/csv" });
            FileSaver.saveAs(blob, analyticsType.toUpperCase() + ".csv");
          }
        },
        (err) => {
          this.api.getError(err);
        }
      );
    } catch (error) {}
  }
  // ***********  SG-7203 start*************************

  ngOnDestroy(): void {
    if (this.subsink) {
      this.subsink.unsubscribe();
    }
  }
  // ***********  SG-7203 end*************************
}
